import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { EMERGING_ENTERPRISE } from "@util/constant";

/**
 * Component to render Enterprise Singapore section on Partners page
 */
const EnterpriseSingaporeSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="enterprise-singapore-section-component"
    >
      <AccordionV2
        testId="enterprise-singapore"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Enterprise Singapore"
            className="px-0"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            Enterprise Singapore is the government agency championing enterprise
            development. The agency works with committed companies to build
            capabilities, innovate and internationalise.
          </p>

          <p>
            It also supports the growth of Singapore as a hub for global trading
            and startups, and builds trust in Singapore’s products and services
            through quality and standards.{" "}
          </p>

          <p>
            Visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={EMERGING_ENTERPRISE}
              target="_blank"
              rel="noreferrer"
            >
              www.enterprisesg.gov.sg
            </a>
            &nbsp;for more information.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default EnterpriseSingaporeSection;
